import React from 'react';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { UserIcon, SignOutIcon } from '../common/Icons';

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <Navbar bg="white" className="border-bottom">
      <Container fluid>

        {/* Bouton sidebar (mobile uniquement) */}
        <Button 
          variant="outline-secondary" 
          className="d-lg-none me-3" 
          onClick={onToggleSidebar}
        >
          ☰
        </Button>

        <Navbar.Brand href="#">
          Facturation
        </Navbar.Brand>

        <Nav className="ms-auto">

          {/* VERSION MOBILE → icône seule */}
          <NavDropdown
            align="end"
            className="d-lg-none"
            title={<UserIcon />}
            id="user-dropdown-mobile"
          >
            <NavDropdown.Item href="/Security">
              <UserIcon className="me-2" />
              Profil
            </NavDropdown.Item>

            <NavDropdown.Divider />

            <NavDropdown.Item onClick={handleLogout}>
              <SignOutIcon className="me-2" />
              Déconnexion
            </NavDropdown.Item>
          </NavDropdown>

          {/* VERSION DESKTOP → nom + icône */}
          <NavDropdown
            align="end"
            className="d-none d-lg-block"
            title={
              <span>
                <UserIcon className="me-2" />
                {user?.name}
              </span>
            }
            id="user-dropdown-desktop"
          >
            <NavDropdown.Item href="/Security">
              <UserIcon className="me-2" />
              Profil
            </NavDropdown.Item>

            <NavDropdown.Divider />

            <NavDropdown.Item onClick={handleLogout}>
              <SignOutIcon className="me-2" />
              Déconnexion
            </NavDropdown.Item>
          </NavDropdown>

        </Nav>

      </Container>
    </Navbar>
  );
};

export default Header;